import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { SignupCategoriesRequest } from '../api/signupcategories/signupcategoriesrequest';
import { SignupCategoriesResponse, SignupCategoriesResponseDtoImpl } from '../api/signupcategories/signupcategoriesresponse';
import { SignupCategoriesBuilder } from '../dto/signupcategories/signupcategoriesbuilder';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class SignupCategoriesAPIProcessorImpl extends SixdeeCRBTAPIProcessor<SignupCategoriesRequest, SignupCategoriesResponse>
{
    execute(request: SignupCategoriesRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new SignupCategoriesResponseDtoImpl(APIFeatures.SIGNUP_CATEGORIES, "Signup Categories Success");

                let signupcategoriesList = new SignupCategoriesBuilder(responseMapper.getResponseMap()).buildAll();
                response.setSignupCategoriesDtos(signupcategoriesList);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new SignupCategoriesResponseDtoImpl(APIFeatures.SIGNUP_CATEGORIES, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new SignupCategoriesResponseDtoImpl(APIFeatures.SIGNUP_CATEGORIES, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new SignupCategoriesResponseDtoImpl(APIFeatures.SIGNUP_CATEGORIES, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
      
            this.getAPIFailure(new SignupCategoriesResponseDtoImpl(APIFeatures.SIGNUP_CATEGORIES, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/signupcategoriesapiprocessor.tsx